import React from "react"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/GlobalVisualSearch/localization"
import { CONTACT_US_PAGE_URL_US } from "@/constants/index"
import { Link } from "@kohler-dsm-library/kohler-core"
import Style from "@/components/GlobalVisualSearch/ErrorFallBack/index.module.scss"
import { sanitizeInnerHtml } from "@/utils/helper"

const ErrorFallBack = props => {
  const { errorPage } = props || {}
  const { t } = useTranslation()
  const { errorText, contactUs, errorSubText } = getTranslations(t)
  const viewGuide = url => {
    window.open(url, "_blank")
  }
  return (
    <div className={Style.ErrorContainer}>
      <div className={`error-section ${errorPage ? "error-page" : ""}`}>
        <p className="sorry-section">{errorText}</p>
        <p className="try-section">{sanitizeInnerHtml(errorSubText)}</p>
      </div>
      <Link
        component="button"
        className="contact-us-button"
        size="medium"
        onClick={() => viewGuide(CONTACT_US_PAGE_URL_US)}
      >
        {contactUs}
      </Link>
    </div>
  )
}

export default ErrorFallBack
